import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from './monitoring.service';
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
  // Don't inject ToastrService directly to avoid circular dependency

  constructor(
    private readonly monitoringService: MonitoringService
  ) {
    super();
  }

  handleError(error: Error) {
    this.monitoringService.logException(error);
  }
}
